// extracted by mini-css-extract-plugin
export default {"filter":"DashBoardConverstation_filter__JxBvI","toggle":"DashBoardConverstation_toggle__DkwgD","round":"DashBoardConverstation_round__NmR7t"};